import React, { useState, useEffect } from "react";

import ProviderManagerTemplatesApi from "apis/providerManagerTemplate";
import { PageLoader, Tab } from "clearsense-ui/components";
import { EmptyState } from "components/Common";

import AssociationTab from "./AssociationTab";

const Associations = ({
  entities,
  currentEntityID,
  currentEntityItemID,
  isViewMode,
  userPermissions,
}) => {
  const [activeTab, setActiveTab] = useState();
  const [allAssociations, setAllAssociations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const OtherEntities = entities?.filter(
    entity => entity.id !== currentEntityID
  );

  const fetchAssociationConfigurations = async () => {
    try {
      setIsLoading(true);
      const { data } = await ProviderManagerTemplatesApi.show(currentEntityID);
      setAllAssociations(data?.associations);
      setActiveTab(
        OtherEntities?.filter(entity =>
          data?.associations?.some(item => item.to === entity.template_id)
        )?.[0]
      );
    } catch (err) {
      logger.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAssociationConfigurations();
  }, []);

  if (isLoading) return <PageLoader />;

  return (
    <div className="space-y-8">
      <div></div>
      <div className="flex flex-col space-y-2">
        <Tab style="primary">
          {OtherEntities?.filter(entity =>
            allAssociations?.some(item => item.to === entity.template_id)
          )?.map(entity => (
            <Tab.Item
              active={entity.name === activeTab?.name}
              key={entity.name}
              className="flex-none flex-grow"
              onClick={() => setActiveTab(entity)}
            >
              {entity.name}
            </Tab.Item>
          ))}
        </Tab>
        {activeTab ? (
          <AssociationTab
            key={activeTab.id}
            sourceEntityItemID={currentEntityItemID}
            currentEntityID={currentEntityID}
            activeTab={activeTab}
            isViewMode={isViewMode}
            userPermissions={userPermissions}
            allAssociations={allAssociations}
            entities={entities}
          />
        ) : (
          <EmptyState
            illustration={<span></span>}
            mainText="No Associated Entities Found"
          />
        )}
      </div>
    </div>
  );
};

export default Associations;
